import { render, staticRenderFns } from "./IconLearning.vue?vue&type=template&id=4faea12c&"
import script from "./IconLearning.vue?vue&type=script&lang=js&"
export * from "./IconLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports